import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["include"];
import { compact, flattenDeep, forEach, head, isArray, isObject, isString, keys, map } from 'lodash';
import { isDateParam, isValidDateParam } from '../utils';
function getPaths(array, currentPath = '') {
  let paths = [];
  forEach(array, value => {
    if (isObject(value)) {
      const path = isArray(value) ? currentPath : `${currentPath}.${head(keys(value))}`;
      paths = paths.concat(getPaths(value, path));
    } else {
      paths.push(`${currentPath}.${value}`);
    }
  });
  return paths;
}
export default function sanitizeParams(params) {
  if (!params) {
    return {};
  }
  // Ensure date params are correct
  forEach(params, (value, key) => {
    if (isDateParam(key)) {
      const isValid = isValidDateParam(value);
      if (!isValid) {
        // Should we throw an error to make the query fail?
        console.error(`date field not including the proper op "${key}=${value}". Valid ops are ">=" and "<="`);
        // throw new Error(`date field not including the proper op: ${key}:${value}`);
      }
    }
  });

  const {
      include
    } = params,
    rest = _objectWithoutPropertiesLoose(params, _excluded);
  const select = compact(include == null ? void 0 : include.map(key => isString(key) ? key : undefined));
  const populate = flattenDeep(compact(include == null ? void 0 : include.map(key => isObject(key) ? map(key, (array, currentPath) => getPaths(array, currentPath)) : undefined)));
  return _extends({}, rest, !!(select != null && select.length) && {
    _select: select.join(',')
  }, !!(populate != null && populate.length) && {
    _populate: populate.join(',')
  });
}